module.exports = __webpack_public_path__ + "img/rugbyleague.d0021e13.svg";